import React, {PropTypes, Component} from 'react';
const s = require('./tags.scss');
import SingleTag from '../SingleTag/SingleTag';

export default class Tags extends Component {
  render() {
    const {links, size} = this.props;
    if (links.length === 0) {
      return <span/>;
    }
    return (
      <div className={s.tagsContainer} data-hook="tags-wrapper">
        <svg data-hook="tags-icon" height="13" width="13.04" viewBox="0 0 13.04 13" className={s.svg}>
          <defs/>
          <path
            className={s.tagSvg}
            d="M1811.61,1715h-4.72a1.084,1.084,0,0,0-.77.33l-5.95,6.02a1.1,1.1,0,0,0-.32.78,1.08,1.08,0,0,0,.32.78l4.71,4.77a1.086,1.086,0,0,0,1.54,0l6.04-6.02a1.2,1.2,0,0,0,.41-0.78v-4.77A1.268,1.268,0,0,0,1811.61,1715Zm0.07,5.95-5.96,6.02a0.1,0.1,0,0,1-.14,0l-4.71-4.76a0.109,0.109,0,0,1,0-.15l6.02-6.06h4.72a0.108,0.108,0,0,1,.1.1Zm-3.86-3.41a1.721,1.721,0,0,0,0,2.4,1.683,1.683,0,0,0,1.19.5,1.643,1.643,0,0,0,1.18-.5A1.686,1.686,0,1,0,1807.82,1717.54Zm1.68,1.69a0.677,0.677,0,0,1-.98,0,0.694,0.694,0,0,1,0-.98,0.651,0.651,0,0,1,.49-0.21,0.666,0.666,0,0,1,.49.21A0.713,0.713,0,0,1,1809.5,1719.23Z"
            transform="translate(-1799.84 -1715)"
            />
        </svg>
        <span className={s.labelsWrapper} data-hook="labels-wrapper">
          {
            links.map((tag, index) => <SingleTag size={size} data-hook="single-tag" key={index} path={tag.path} label={`${tag.name}${index !== links.length - 1 ? ',' : ''}`}/>)
          }
        </span>
      </div>
    );
  }
}

Tags.propTypes = {
  links: PropTypes.array.isRequired,
  size: PropTypes.string
};



// WEBPACK FOOTER //
// ./components/partial/Tags/Tags.js